import React, { useEffect, useState } from "react";
import { ChefHat } from "lucide-react";

export default function Splash() {
  const [leaving, setLeaving] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 1100);
    const t2 = setTimeout(() => setGone(true), 1650);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="app-splash"
      className={`fixed inset-0 z-[999] flex flex-col items-center justify-center bg-[#0E0E0E] transition-opacity duration-500 ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="flex flex-col items-center gap-4 splash-pop">
        <div className="h-20 w-20 rounded-2xl bg-[#E11D2A] flex items-center justify-center shadow-[0_0_44px_rgba(225,29,42,0.35)]">
          <ChefHat className="h-11 w-11 text-white" />
        </div>
        <div className="text-center">
          <p className="font-heading text-2xl font-bold text-white leading-none">Paige's Bistro</p>
          <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-[#6B6B6B] mt-2">Station Checklists</p>
        </div>
      </div>
      <div className="absolute bottom-16 h-1 w-24 overflow-hidden rounded-full bg-[#232323]">
        <div className="h-full w-1/2 rounded-full bg-[#E11D2A] splash-bar" />
      </div>
    </div>
  );
}
